import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Estilos específicos para el paso 2 de intercambio
// Estos estilos sobrescriben los compartidos solo para este componente
export const ExchangeStep2MainContainer = styled(Box)({
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  backgroundColor: 'transparent',
  gap: '12px', // Espacio reducido entre las columnas (más delgado)
  margin: '-24px', // Compensar el padding del ContentContainer
  padding: '24px', // Aplicar padding directamente aquí para que coincida con header
});

export const ExchangeStep2LeftColumn = styled(Box)({
  flex: 1,
  overflow: 'auto',
  backgroundColor: 'transparent',
  // Sin padding aquí, el MainContainer ya maneja el padding de 24px
});

export const ExchangeStep2RightColumn = styled(Box)({
  width: 400,
  overflow: 'auto',
  backgroundColor: 'transparent',
  // Sin padding aquí, el MainContainer ya maneja el padding de 24px
});
